import { render, staticRenderFns } from "./TeamScout.vue?vue&type=template&id=5faff548&scoped=true&"
import script from "./TeamScout.vue?vue&type=script&lang=ts&"
export * from "./TeamScout.vue?vue&type=script&lang=ts&"
import style0 from "./TeamScout.vue?vue&type=style&index=0&id=5faff548&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faff548",
  null
  
)

export default component.exports